export default class GraduacionesClienteEncargoBuilder {
  static build({ mostrar }) {
    return {
      mostrar: mostrar || false,
      optometricas: {
        seleccion: {
          id: null,
          tiendaId: null,
        },
        listado: [],
      },
      contactologicas: {
        seleccion: {
          id: null,
          tiendaId: null,
        },
        listado: [],
      },
    };
  }
}
